module.exports = __webpack_public_path__ + "static/media/BottlePickup.7572ac20.png";